import React, { useEffect } from 'react';
import { Alert } from 'reactstrap';

import { getErrorMessage } from '~libs/axiosWrapper';

import { ErrorResponse, Spinner } from '~components';
import Icon, { faCheckCircle } from '~components/icon';

import { useCreateMutation } from '~support-at-home/actions/clientInvoices';

interface ComponentProps {
  value: { invoice_date: string; due_date: string; service_date_to?: string };
}

const Review: React.FC<ComponentProps> = ({ value }) => {
  const { invoice_date, due_date, service_date_to } = value;

  const [createClientInvoices, { data, error, isLoading }] = useCreateMutation();

  useEffect(() => {
    createClientInvoices({ invoice_date, due_date, ...(service_date_to ? { service_date_to } : {}) });
  }, []);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner loading={isLoading} />
        <p className="mt-3 text-muted">Generating client invoices...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <ErrorResponse message={getErrorMessage(error)} />
      </div>
    );
  }

  if (!data) return null;

  return (
    <Alert color="success" className="w-100 mb-3">
      <Icon icon={faCheckCircle} className="me-2" />
      <b>Client Invoices Generated</b>
      <div className="mt-2">
        <p className="mb-1">
          <strong>{data.invoices_count}</strong> client invoice{data.invoices_count !== 1 ? 's' : ''} created
        </p>
      </div>
    </Alert>
  );
};

export default Review;
